module.exports = __webpack_public_path__ + "static/media/playspace_header_background.5d5b39bb.png";